@let i18n = translate();
<div class="rcp-flex rcp-h-screen rcp-items-center rcp-justify-center">
    <div class="rcp-text-center">
        @if (statusCode === 404) {
            <h4 class="rcp-p-2 rcp-text-[100px]">
                {{ '4' }}<mat-icon class="rcp-h-[200px]">mood_bad</mat-icon>{{ '4' }}
            </h4>
            <h4>{{ i18n.PageNotFound }}</h4>
            <p>
                {{ i18n.PageNotFound_Message }}
            </p>
        } @else {
            <h4 class="rcp-p-2 rcp-text-[100px] rcp-text-ul-red-300">
                {{ '4'
                }}<mat-icon class="rcp-h-[200px] rcp-text-ul-red-300">block</mat-icon
                >{{ '1' }}
            </h4>
            <h4 class="rcp-p-2 rcp-text-xl">{{ i18n.UnAuthorized }}</h4>
            <p>{{ i18n.UnAuthorized_Message }}</p>

            <button
                mat-button
                class="goHomeBtn rcp-mt-2"
                [attr.data-testid]="'rcp-error-go-default-page-btn'"
                (click)="onRetryClicked($event)"
            >
                <div class="rcp-flex">
                    <mat-icon class="rcp-refresh-icon">refresh</mat-icon
                    ><span> {{ 'Retry' }} </span>
                </div>
            </button>
        }
    </div>
</div>
